import {FactoryProvider, InjectionToken, Provider} from '@angular/core';
import {AuthOptions} from 'auth0-js';
import {Auth0Config} from '../interfaces/auth0';

export const AUTH0_CONFIG:InjectionToken<Auth0Config> = new InjectionToken('auth0_config');

export const Auth0ConfigProvider:Provider = {provide: AUTH0_CONFIG, useValue: null};

export const AUTH_OPTIONS:InjectionToken<AuthOptions> = new InjectionToken('auth0_options');

export const AuthOptionsProvider:FactoryProvider = {
	provide: AUTH_OPTIONS,
	useFactory: getAuthOptions,
	deps: [AUTH0_CONFIG]
};

export function getAuthOptions(config:Auth0Config):AuthOptions {
	return Object.assign({
		domain: config.auth0Domain,
		clientID: config.clientID,
		redirectUrl: config.callbackURL,
		responseType: (config.internalOptions || {}).response_type || config.callbackOnLocationHash ? 'token' : 'code',
	}, config.internalOptions);
}